<template>
  <a-config-provider :locale="esEs">
    <component :is="($route.meta && $route.meta.layout) || 'div'">
      <router-view />
    </component>
  </a-config-provider>
</template>

<script>
import esEs from 'ant-design-vue/es/locale/es_ES'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import env from '@/env'

dayjs.locale('es')

export default {
  name: 'App',
  setup() {
    document.title = env('VUE_APP_NOMBRE_SISTEMA')
    return { esEs }
  }
}
</script>